<script>
// https://safrazik.com/vue-file-agent/docs/#props
// https://lian-yue.github.io/vue-upload-component/#/en/examples/full
// https://openbase.com/js/vue-image-crop-upload/alternatives?orderBy=RECOMMENDED&
import Vue from 'vue';
import userService from '../../services/user.js';
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';

Vue.use(VueFileAgent);

export default {
    name: "p-user-logo2",
    
    data: function () {
      return {
        fileRecords: [{
            "atualizar-logo-perfil": true,
        }],
        uploadUrl: 'includes/php/ajax_update.php?atualizar-logo-perfil=true',
        uploadHeaders: {},
        fileRecordsForUpload: [], // maintain an upload queue
        show : false,
      };
    },
    methods: {
      toggleShow() {
        this.show = !this.show;
      },
      uploadFiles: function () {
        // Using the default uploader. You may use another uploader instead.
        this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload);
        this.fileRecordsForUpload = [];
      },
      uploaded: function(e) {
          alert("Imagem salva com sucesso.");
          this.toggleShow();
      },
      uploadError : function(e) {
          alert("Ocorreu um erro ao enviar o arquivo.");
      },
      deleteUploadedFile: function (fileRecord) {
        // Using the default uploader. You may use another uploader instead.
        this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
      },
      filesSelected: function (fileRecordsNewlySelected) {
        var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
        this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
      },
      onBeforeDelete: function (fileRecord) {
        var i = this.fileRecordsForUpload.indexOf(fileRecord);
        if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
          this.fileRecordsForUpload.splice(i, 1);
          var k = this.fileRecords.indexOf(fileRecord);
          if (k !== -1) this.fileRecords.splice(k, 1);
        } else {
          if (confirm('Are you sure you want to delete?')) {
            this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
          }
        }
      },
      fileDeleted: function (fileRecord) {
        var i = this.fileRecordsForUpload.indexOf(fileRecord);
        if (i !== -1) {
          this.fileRecordsForUpload.splice(i, 1);
        } else {
          this.deleteUploadedFile(fileRecord);
        }
      },
    },
  };
</script>

<template>
    <div class="wrapper">
       <button @click="toggleShow" class="btn btn-sm btn-success">Alterar logotipo</button>
       <div >
            <transition name="modal">
                <div class="modal-mask" v-if="show" >
                    <div class="modal-wrapper">
                        <div class="modal-container">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="toggleShow">×</button>
                                        <!-- <h4 class="modal-title"> {{ title }} </h4> -->
                                    </div>
                                    <div class="modal-body">
                                        <VueFileAgent
                                            ref="vueFileAgent"
                                            :theme="'default'"
                                            :multiple="false"
                                            :deletable="false"
                                            :meta="true"
                                            :accept="'image/*'"
                                            :maxSize="'300KB'"
                                            :maxFiles="1"
                                            :helpText="'Escolha a imagem do seu logotipo'"
                                            :errorText="{
                                                type: 'Tipo de arquivo inválido. Apenas imagens são permitidas',
                                                size: 'O arquivo não pode ser maior que 300Kb',
                                            }"
                                            @select="filesSelected($event)"
                                            @upload="uploaded($event)"
                                            @upload:error="uploadError($event)"
                                            v-model="fileRecords"
                                        ></VueFileAgent>
                                        <div class="col-md-12">
                                            <button class="btn btn-primary float-right" :disabled="!fileRecordsForUpload.length" @click="uploadFiles()">
                                                Enviar Logotipo
                                            </button>
                                        </div>
                                    </div>
                                    <!-- <div class="modal-footer">
                                        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('close')">Não</button>
                                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$emit('clickYesModal', action)">Sim</button>
                                    </div> -->
                                </div><!-- /.modal-content -->
                            </div><!-- /.modal-dialog -->
                        </div>
                    </div>
                </div>
            </transition>
        </div><!-- /.modal -->
        
  </div>
</template>

<style lang="scss">
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-content {
        overflow-y: auto;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
  


// WEBPACK FOOTER //
// src/js/components/profile/p-user-logo2.vue